export default [
    {
        date: 1617902170615,
        row: 15,
        col: 17,
        segments: [
            [7, 2, 11, 2],
            [7, 4, 7, 2],
            [11, 4, 11, 2],
            [9, 5, 7, 4],
            [11, 4, 9, 5],
            [9, 3, 9, 4],
            [7, 3, 8, 3],
            [8, 2, 8, 3],
            [8, 3, 7, 2],
            [10, 2, 10, 3],
            [11, 3, 10, 3],
            [10, 3, 11, 2],
            [8, 5, 7, 4],
            [10, 5, 11, 4],
            [7, 5, 8, 5],
            [10, 5, 11, 5],
            [6, 6, 7, 5],
            [12, 6, 11, 5],
            [6, 9, 6, 6],
            [12, 6, 12, 9],
            [7, 11, 6, 9],
            [11, 11, 12, 9],
            [5, 5, 6, 7],
            [4, 5, 5, 5],
            [3, 8, 4, 5],
            [3, 10, 3, 8],
            [5, 12, 3, 10],
            [3, 12, 5, 12],
            [2, 13, 3, 12],
            [3, 13, 2, 13],
            [4, 14, 3, 13],
            [5, 13, 4, 14],
            [6, 14, 5, 13],
            [7, 13, 6, 14],
            [11, 13, 7, 13],
            [12, 14, 11, 13],
            [13, 13, 12, 14],
            [14, 14, 13, 13],
            [15, 13, 14, 14],
            [16, 13, 15, 13],
            [15, 12, 16, 13],
            [13, 12, 15, 12],
            [15, 10, 13, 12],
            [15, 8, 15, 10],
            [14, 5, 15, 8],
            [13, 5, 14, 5],
            [12, 6, 13, 5],
            [8, 7, 10, 7],
            [10, 9, 10, 7],
            [8, 9, 10, 9],
            [8, 7, 8, 9],
        ],
    },
    {
        date: 1425327124072,
        row: 15,
        col: 17,
        segments: [
            [7, 2, 11, 2],
            [11, 2, 11, 4],
            [11, 4, 9, 5],
            [9, 5, 7, 4],
            [7, 4, 7, 2],
            [7, 3, 8, 2],
            [10, 2, 11, 3],
            [8, 5, 7, 4],
            [10, 5, 11, 4],
            [7, 5, 8, 5],
            [7, 5, 6, 6],
            [6, 6, 6, 9],
            [6, 9, 7, 11],
            [7, 11, 7, 13],
            [7, 13, 8, 12],
            [8, 12, 8, 13],
            [8, 13, 9, 12],
            [9, 12, 9, 11],
            [9, 11, 8, 10],
            [8, 10, 7, 8],
            [7, 8, 7, 7],
            [10, 5, 11, 5],
            [11, 5, 12, 6],
            [12, 6, 13, 8],
            [13, 8, 12, 10],
            [12, 10, 12, 12],
            [12, 12, 11, 13],
            [11, 13, 11, 12],
            [11, 12, 10, 13],
            [10, 13, 10, 11],
            [10, 11, 11, 9],
            [11, 9, 11, 7],
            [12, 6, 13, 5],
            [13, 5, 14, 5],
            [14, 5, 15, 8],
            [15, 8, 15, 10],
            [15, 10, 13, 12],
            [13, 12, 15, 12],
            [15, 12, 16, 13],
            [16, 13, 15, 13],
            [15, 13, 15, 14],
            [15, 14, 14, 13],
            [14, 13, 14, 14],
            [14, 14, 13, 13],
            [13, 13, 5, 13],
            [5, 13, 5, 14],
            [5, 14, 4, 13],
            [4, 13, 3, 14],
            [3, 14, 3, 13],
            [3, 13, 2, 13],
            [2, 13, 3, 12],
            [3, 12, 5, 12],
            [7, 13, 6, 12],
            [6, 12, 5, 9],
            [5, 9, 5, 8],
            [5, 12, 3, 10],
            [3, 10, 3, 8],
            [3, 8, 4, 5],
            [4, 5, 5, 5],
            [5, 5, 6, 7],
            [10, 2, 9, 3],
            [9, 3, 10, 4],
            [10, 4, 11, 3],
            [8, 2, 9, 3],
            [9, 3, 8, 4],
            [7, 3, 8, 4],
            [7, 4, 11, 4],
        ],
    },
];
